// extracted by mini-css-extract-plugin
module.exports = {"numbers":"e_KJ","numbersOne":"e_LJ","numbersIconWrapper":"e_MJ","numbersIcon":"e_NJ","numbersTitle":"e_OJ","numbersSubTitle":"e_PJ"};